import Spec from "./Spec"
// import SpecAuto from "./SpecAuto"
import SpecFunction from "./SpecFunction"
import SpecTernaryOperator from "./SpecTernaryOperator"
import SpecValue from "./SpecValue"

export abstract class SpecManager {
    specs: Spec[] = []

    listFields: string[] = []

    dependencies: any = {}
    public fields: {[k: string]: Spec} = {}

    toStream: boolean = false
    fromDependencies: {[k: string]: string[]} = {}

    dependenciesErrors = []

    stream: { [k: string]: { userValue: string | number | boolean, computedValue: number }} = {}

    constructor(
        public rules: { [k: string]: any },
        public readonly: boolean,
        stream: { [k: string]: { userValue: string | number | boolean, computedValue: number }},
    ) {
        if (stream) {
            this.stream = stream
        }
    }

    get filterDependencyKeys(): string {
        return ""
    }

    get name() {
        return ""
    }

    createValue(key: string, readonly:boolean): SpecValue {
        const spec = new SpecValue(key, this, readonly)
        if (this.stream?.[key]) {
            spec.setStream(this.stream[key])
        }
        return spec
    }

    createFunction(key: string, func: string, readonly: boolean): SpecFunction|SpecTernaryOperator {

        let spec
        const values = func.split("?")

        if (values.length >= 2 && values[1].length) {
            const second = values[1]
            let a,b
            let insideHook:boolean = false
            for (let i = 0; i < second.length; i++) {
                if (second[i] === "[") {
                    insideHook = true
                } else if (second[i] === "]") {
                    insideHook = false
                }
                if (!insideHook && second[i] === ":") {
                    a = second.substring(0, i)
                    b = second.substring(i+1)
                    break
                }
            }
            if (!!a && !!b) {
                spec = new SpecTernaryOperator(key, values[0], a, b, this, readonly)
            } else {
                console.error("wrong ternary operator")
            }
        }
        if (!spec) {
            spec = new SpecFunction(key, func, this)
        }
        // dependencies
        this.dependencies[key] = Spec.getDependencies(func)
        // stream
        if (this.stream?.[key]) {
            spec.setStream(this.stream[key])
        }

        return spec
    }

    // createAuto(key: string): SpecAuto {
    //     let func = this.rules[key].function
    //     const regex = /(\[.*?\])/g
    //     let m
    //     let newF = func
    //     let newFN1 = func
    //     while ((m = regex.exec(func)) !== null) {
    //         // This is necessary to avoid infinite loops with zero-width matches
    //         if (m.index === regex.lastIndex) {
    //             regex.lastIndex++
    //         }
    //         // The result can be accessed through the `m`-variable.
    //         m.forEach((match, groupIndex) => {
    //             // debugger
    //             if (groupIndex === 1) {
    //                 if (match.includes("RAD")) {
    //                     newF = newF.replace(match, `(+this.specManager.radicals?.[${match.slice(1, -1).replace("RAD", "")}] || 0)`)
    //                     // newFN1 = newFN1.replace(match, `(+this.specManager.radicals?.['${match.slice(1, -1).replace("RAD", "") + 'N1'}'] || 0)`)
    //                 } else if (match.includes("CPT")) {
    //                     newF = newF.replace(match, `(+this.specManager?.bundleBase?.aaClassesBalanceSum?.[${match.slice(1, -1).replace("CPT", "")}] || 0)`)
    //                     // newFN1 = newFN1.replace(match, `(+this.specManager?.bundleBase?.aaClassesBalanceSum?.['${match.slice(1, -1).replace("CPT", "") + 'N1'}'] || 0)`)
    //                 } else if (match.includes("[")) {
    //                     newF = newF.replace(match, `(+this.fields?.[${match.slice(1, -1)}]?.value || 0)`)
    //                     // newFN1 = newFN1.replace(match, `(+this.fields?.['${match.slice(1, -1) + 'N1'}']?.value || 0)`)
    //                 }
    //             }
    //         })
    //     }

    //     debugger
    //     const spec = new SpecAuto(key, newF, this)
    //     if (this.stream?.[key]) {
    //         spec.setStream(this.stream[key])
    //     }

    //     return spec
    // }

    getFields(): {[k: string]: Spec} {
        return this.fields
    }

    fillSpecs(specs:{[k: string]: Spec}) {
        for (const key in this.fields) {
            const spec = this.fields[key]
            if (specs) {
                specs[spec.uniqueKey] = spec
            } else {
                debugger
            }
        }
    }

    abstract afterUpdate()

    update() {
        // console.log("--------")
        // console.log("FORM UPDATE", this.name)
        // console.log("--------")
        for (const spec of this.specs) {
            // if (spec.key === 'GE') debugger
            // console.log("KEY UPDATE", spec.key)
            const used = []
            // const logKey = this.name + "_" + spec.key
            spec.update(used)
        }
        // for (const spec of this.specs) {
        //     spec.resetUpdate()
        // }
        this.afterUpdate()
    }

    initializeFields() {
        this.fields = {}
        if (!this.listFields.length) {
            // throw new Error("No fields to initialize");
            return this.fields
        }

        for (const f of this.listFields) {
            const createdObject = this.initializeField(f)
            if (createdObject) {
                this.fields[f] = createdObject
            } else {
                console.error("createdObject no created for f=", f)
            }
        }
        return this.fields
    }

    updateDependencies(allSpecs) {
        this.dependenciesErrors = []
        for (const functionFieldKey in this.dependencies) {
            let dependencyKeys = this.dependencies[functionFieldKey]
            if (dependencyKeys?.length) {
                if (this.fields[functionFieldKey]) {
                    const dependencies = []
                    for (const dependencyKey of dependencyKeys) {
                        let index = dependencyKey.indexOf("@")
                        if (index !==-1) {
                            const lDependencyKey = dependencyKey.substring(0,index) + dependencyKey.substring(index+1)
                            if (allSpecs[lDependencyKey]) {
                                dependencies.push(allSpecs[lDependencyKey])
                            }
                        } else {
                            if (this.fields[dependencyKey]) {
                                dependencies.push(this.fields[dependencyKey])
                            } else if (allSpecs[dependencyKey]) {
                                dependencies.push(allSpecs[dependencyKey])
                            } else if (dependencyKey.startsWith("SUM:")) {
                                for (const key in this.fields) {
                                    if (key.startsWith(dependencyKey.slice(4))) {
                                        dependencies.push(this.fields[key])
                                    }
                                }
                                // dependencies.push(allSpecs[dependencyKey])
                            } else if (!this.filterDependencyKeys || !dependencyKey.startsWith(this.filterDependencyKeys)) {
                                if (!dependencyKey.startsWith("RAD") && !dependencyKey.startsWith("CPT") && !dependencyKey.startsWith("N1CEL:")) {
                                    console.error("no dependencyKey in form", this.name, "in function : ", functionFieldKey, "in field : ", dependencyKey)
                                    this.dependenciesErrors.push({function: functionFieldKey, error:"dependency-missing",field: dependencyKey})
                                }
                            }
                        }
                    }
                    if (dependencies?.length) {
                        this.fields[functionFieldKey].setDependencies(dependencies)
                    }
                } else {
                    console.error("no functionFieldKey in fields= ", functionFieldKey)
                    this.dependenciesErrors.push({function: functionFieldKey, error:"field-missing" })
                }
            }
        }
        // console.log("Fields after init", this.fields)
        // this.update()
    }

    initializeField(field: string) {
        if (this.isFunction(field)) {
            // if (this.isRadical(field)) {
            //     return this.createAuto(field)
            // }
            if (this.isFromOtherForm(field)) {
                this.addFromDependency(field)
            }
            return this.createFunction(field, this.rules[field].function, this.rules[field].readonly)
        }
        return this.createValue(field, this.rules[field]?.readonly)
    }

    isFunction(field) {
        return !!this.rules?.[field]?.function
    }

    isFromOtherForm(field: string) {
        if (!!this.rules?.[field]?.function) {
            return (/[^ |N1]{2}:/g).test(this.rules?.[field]?.function)
        }
        return false
    }

    isRadical(field) {
        let result = !!this.rules?.[field]?.function.includes("RAD") || !!this.rules?.[field]?.function.includes("CPT")
        return result
    }

    addFromDependency(field: string) {
        if (!this.rules[field].function) {
            return
        }
        let externalFields = []
        const regexExternalFields =  /\[([0-Z]+:[A-Z]+)\]/g
        const externalFieldMatches = this.rules[field].function.match(regexExternalFields)
        if (externalFieldMatches) {
            for (const match of externalFieldMatches) {
                externalFields.push(match.toString())
                const key = match.replace("[", "").replace("]", "")
                if (!this.fromDependencies?.[field]?.includes(key)) {
                    if (this.fromDependencies?.[field]) {
                        this.fromDependencies[field].push(key)
                    } else {
                        this.fromDependencies[field] = [key]
                    }
                }
            }
        }
        const regexLocalFields = /\[([0-Z]+)\]|\[([0-Z]+_[0-9]+)\]/g
        const localFieldsMatches = this.rules[field].function.match(regexLocalFields)
        if (localFieldsMatches?.length) {
            for (const match of localFieldsMatches) {
                if (externalFields.includes(match.toString())) {
                    continue
                }
                const key = match.replace("[", "").replace("]", "")

            }
        }
    }

    getFromDependencies() {
        let result = [...new Set(Object.values(this.fromDependencies).flat())]
        return result
    }

    getImpactedFields(field: string) {
        if (this.rules[field] === undefined) {
            return []
        }
        return this.rules[field].impacted
    }

    addExternalFields(key, value) {
        this.fields[key] = value
        for (let keyFromDep in this.fromDependencies) {
            if (this.fromDependencies[keyFromDep].includes(key)) {
                this.fields[keyFromDep].setDependencies([value], key)
            }
        }
    }

    getValues() {
        let result = {}
        for (let key in this.fields) {
            let k = key
            if (key.includes(":")) {
                continue
            }
            result[k] = this.fields[key].getStreamValue()
        }
        return result
    }

    // buildAllFields() {
    //     for (let key in this.fields) {
    //         this.fields[key].build()
    //     }
    // }
}
